<template>
  <v-scroll-y-reverse-transition mode="out-in">
    <router-view
      :active="active"
      :installed="installed"
      :modal="modal"
      :dev="dev"
    />
  </v-scroll-y-reverse-transition>
</template>

<style>
  :root {
    --safe-area-top: env(safe-area-inset-top);
    --safe-area-right: env(safe-area-inset-right);
    --safe-area-left: env(safe-area-inset-left);
    --safe-area-bottom: env(safe-area-inset-bottom);
  }

  *:not(input):not(textarea) {
    user-select: none !important;
    -webkit-user-select: none !important; /* Chrome, Safari, and Opera */
    -webkit-touch-callout: none !important; /* Disable Android and iOS callouts*/
  }
  body input, body textarea {
    user-select: text !important;
    -webkit-touch-callout: text !important;
    -webkit-user-select: text !important;
  }
  ::-webkit-scrollbar {
    opacity: 0;
    width: 0;
    display: none;
    background-color: transparent;
  }

  html, body, #app.theme--dark.v-application {
    background: var(--v-background-base) !important;
    width: 100%;
    min-height: 100%;
    /* min-height: calc(100% + var(--safe-area-top));
    padding: var(--safe-area-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);  */
  }
  #app .v-sheet, .v-input > .v-input__control > .v-input__slot {
    background-color: var(--v-background-base);
    /* margin-top: var(--safe-area-top) !important; */
  }
  #app .v-card.transparent, .v-input.transparent > .v-input__control > .v-input__slot {
    background-color: transparent !important;
    /* margin-top: var(--safe-area-top) !important; */
  }
  #app .v-overlay__scrim {
    background-color: var(--v-background-base) !important;
  }

  #app .text-caption {
    font-family: "Roboto Mono", sans-serif !important;
    font-size: .6975rem !important;
  }
  #app .text-tech {
    font-family: "Roboto Mono", sans-serif !important;
    letter-spacing: 0 !important;
  }

  .v-toolbar__content > .v-btn.v-btn--icon:first-child + .v-toolbar__title, .v-toolbar__extension > .v-btn.v-btn--icon:first-child + .v-toolbar__title {
    padding-left: 8px;
  }
  #app .container {
    overflow: hidden;
  }
  i {
    font-style: normal;
  }

  #app .v-dialog--fullscreen .sheet {
    height: 100%;
    border-radius: 0;
    background: var(--v-background-base);
    padding-top: var(--safe-area-top) !important;
    padding-bottom: var(--safe-area-bottom) !important;
  }
  body,
  .v-navigation-drawer,
  .v-overlay__content > .v-sheet {
    padding-top: var(--safe-area-top) !important;
    padding-bottom: var(--safe-area-bottom) !important;
  }
  .v-bottom-sheet .v-sheet {
    padding-bottom: var(--safe-area-bottom) !important;
  }
  .v-app-bar:not(.v-app-bar--bottom) {
    padding-top: var(--safe-area-top) !important;
  }
  .v-app-bar--bottom {
    padding-bottom: var(--safe-area-bottom) !important;
  }
  #app .sheet.fill-height {
    min-height: 100%;
    height: auto;
    background: var(--v-background-base);
  }
  #app .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 90%;
  }
  #app .v-dialog.v-dialog--fullscreen {
    max-height: 100%;
    top: auto;
  }

  #app .app-bar .title, #app .page-header .title {
    font-size: 1rem !important;
    font-weight: 400 !important;
    line-height: 1.5rem !important;
    text-transform: uppercase !important;
    letter-spacing: .1rem !important;
  }

  #app .sheet .content {
    max-height: calc(100% - 56px);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  #app .empty-icon {
    max-width: 40%;
  }

  #app .card-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    opacity: .24;
    pointer-events: none;
  }

  #app .theme--dark.v-btn:focus::before {
    opacity: 0 !important;
  }

  .scrollable {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .scrollable.x {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .smooth-scroll {
    scroll-behavior: smooth;
  }
  .prevent-scroll {
    overflow-y: hidden !important;
  }
  .snap {
    overflow-y: scroll !important;
    scroll-snap-type: y mandatory;
    /* scroll-padding: 8px;
    scroll-margin: 8px; */
  }
  .snap.x {
    overflow-x: scroll !important;
    scroll-snap-type: x mandatory;
    /* scroll-padding: 8px;
    scroll-margin: 8px; */
  }
  .snap.both {
    overflow: scroll !important;
    scroll-snap-type: both mandatory;
    /* scroll-padding: 8px;
    scroll-margin: 8px; */
  }
  .snap-target {
    scroll-snap-align: start;
  }

  .text-untruncate {
    overflow: initial !important;
    text-overflow: initial !important;
    white-space: initial !important;
  }

  .w-100 {
    width: 100%;
  }
  .w-75 {
    width: 75%;
  }
  .w-50 {
    width: 50%;
  }
  .w-25 {
    width: 25%;
  }

  .animate.pulse {
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% {
      opacity: .6;
    }
    50% {
      opacity: .4;
    }
    100% {
      opacity: .6;
    }
  }
  @keyframes jump {
    0%   { transform: scale(1); }
    16%  { transform: scale(1.05); }
    33%  { transform: scale(1); }
    50%  { transform: scale(1.05); }
    66%  { transform: scale(1); }
    83%  { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
  @keyframes wobble {
    0%   { transform: translateX(0); }
    15%  { transform: translateX(-.25rem) }
    30%  { transform: translateX(.25rem) }
    45%  { transform: translateX(-.25rem) }
    60%  { transform: translateX(.25rem) }
    75%  { transform: translateX(-.125rem) }
    100% { transform: translateX(0); }
  }
  @keyframes grow-glow {
    0% {
      transform: scale(1);
      box-shadow: none;
    }
    40% {
      transform: scale(1.025);
      box-shadow: 0 0 .5rem .125rem color-mix(in srgb, var(--color) 64%, transparent);
    }
    80% {
      transform: scale(1);
      box-shadow: 0 0 .25rem .125rem color-mix(in srgb, var(--color) 24%, transparent);
    }
    100% {
      transform: scale(1);
      box-shadow: none;
    }
  }

  .theme--dark input:-webkit-autofill,
  .theme--dark input:-webkit-autofill:hover, 
  .theme--dark input:-webkit-autofill:focus,
  .theme--dark textarea:-webkit-autofill,
  .theme--dark textarea:-webkit-autofill:hover,
  .theme--dark textarea:-webkit-autofill:focus,
  .theme--dark select:-webkit-autofill,
  .theme--dark select:-webkit-autofill:hover,
  .theme--dark select:-webkit-autofill:focus {
    -webkit-text-fill-color: white;
    -webkit-box-shadow: 0 0 0px 1000px var(--v-background-base) inset;
    transition: background-color 5000s ease-in-out 0s;
  }

</style>

<script>

  import services from '@/services.js'
  import { App } from '@capacitor/app';
  import { Capacitor } from '@capacitor/core';
  import { sync } from 'vuex-pathify'
  import OneSignal from 'onesignal-cordova-plugin';

  export default {
    name: 'App',

    metaInfo () {
      const titleTemplate = this.$tc('general.partner', 2);
      return {
        title: 'Mobees',
        titleTemplate: (title) => `${title} | ${titleTemplate}`,
        htmlAttrs: { lang: 'en' },
        meta: [{ charset: 'utf-8' }],
      }
    },

    data: () => ({
      refreshing: false,
      registration: null,
      updateExists: false,
      temp: {},
      modal: null,
      active: true,
      locale: null,
      ghost: null,
      dev: process.env.NODE_ENV != 'production',
      installed: Capacitor.isNativePlatform(),
    }),

    computed: {
      version: sync('app/version'),
      user: sync('user'),
      toast: sync('app/toast'),
    },

    watch: {
      $route: {
        immediate: true,
        handler (route) {
          this.modal = _.get(route.query, 'view', null);
          
          if (_.has(route.query, 'debug')) {
            this.setStorage('debug', true, 'sessionStorage');
            this.dev = true;
          }else if (!this.dev) {
            this.getStorage('debug', 'sessionStorage').then(value => {
              this.dev = value===true;
            });
          }
        },
      },
      isOnline: {
        immediate: true,
        handler (on) {
          this.toggleToast(
            !on,
            this.$t('errors.no_internet'),
            -1,
            false,
          );
        },
      }
    },

    methods: {
      ...services,

      setupI18n () {
        this.setLocale();
      },

      onStateChange ({ isActive }) {
        this.active = isActive;

        if (isActive&&!this.ghost) {
          this.getStorage('user').then((user) => {
            if (user && user.auth && user.auth.token) {
              const activeAt = parseInt(user.activeAt);
              if (this.$moment().subtract(1, 'hour').isAfter(activeAt)) {
                this.log(user);
              }
            }
          });
        }
      },

      showRefreshUI () {
        // this.registration = e.detail;

        this.toggleToast(
          true,
          'Nova versão do app disponível!',
          0,
          {
            toggle: true,
            text: 'Atualizar',
            action: this.refreshApp
          },
        )
      },
      
      async refreshApp () {
        this.updateExists = false;
        // localStorage.removeItem("vuex");

        // if (this.user.auth.status) this.user = Object.assign(this.user, this.temp);
        // this.temp.updated = true;
        // if (this.user.auth.status) this.temp.user = this.user;
        // localStorage.setItem("temp", JSON.stringify(this.temp));
        this.setStorage('updated', true);

        await this.$workbox.messageSW({ type: "SKIP_WAITING" });
        // this.showUpgradeUI = false

        // if (!this.registration || !this.registration.waiting) { return; }
        // this.registration.waiting.postMessage('skipWaiting');
      },

      log (user) {
        const username = user.username;
        const token = user.auth.token;

        this.$api({
          url: '/driver/log',
            method: 'POST',
            data: {
              username,
              token,
            }
          })
          .then(response => {
            console.log('log => ', response);
            user.activeAt = Date.now();
            this.setStorage('user', user);
          })
          .catch(error => {
            this.handleError(error);
          })

      },

      adjustUI () {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      },

      OneSignalInit () {
        // OneSignal.Debug.setLogLevel(6);
        OneSignal.initialize("162a5a01-8253-46a8-bee7-664c5afd968c");
        OneSignal.Notifications.requestPermission(false).then((accepted) => {
          console.log("### User accepted notifications: " + accepted);
        });
      },
    },

    mounted () {
      this.setupI18n();
      
      this.$router.onReady(() => {
        const route = this.$route;
        this.getStorage('user').then((user) => {
          if (route.name=='file'||route.name=='Manutenção') return;
          
          if ((user===null||user.auth.token==null)&&(route.path.includes('/main')||route.path.includes('/signup'))) {
            this.$router.push('/');
          }else if (!!user&&user.auth.token!=null&&user.status!=null) {
            this.getStorage('ghost').then((value) => {
              this.ghost = value;
              if (!value) this.log(user);
            });
            if (['ACT', 'EXP'].includes(user.status)) {
              if (!route.path.includes('/main')) this.$router.push('/main');
            }else if (!route.path.includes('/signup')){
              this.$router.push('/signup');
            }
          }
        });
      });
      
      this.getStorage('updated').then((updated) => {
        if (updated===true) {
          // setTimeout(() => {
          //   this.toggleToast(
          //     true,
          //     'App atualizado!',
          //     3000,
          //     false
          //   )
          // }, 500);
          this.setStorage('updated', false);
        }
      });

      if (this.$workbox) {
        this.$workbox.addEventListener("waiting", () => {
          this.showRefreshUI();
        });
      }

      if (this.installed) {
        document.addEventListener("deviceready", this.OneSignalInit, false);
      }
      // this.adjustUI();
      // window.addEventListener('resize', this.adjustUI);

      this.version = APP_VERSION;
      console.log('### APP_VERSION', this.version);

      App.addListener('appStateChange', this.onStateChange);

      App.addListener('appUrlOpen', (event) => {
        const schemes = ['parceiros.mobees.com.br', 'mobees:/'];
        const scheme = schemes.find(s => event.url.includes(s)) || null;
        if (!scheme) return;
        const path = event.url.split(scheme).pop();
        console.log('### App opened with URL: ' + event.url, path);
        if (path) {
          this.$router.push(path);
        }
      });

      // const version = localStorage.getItem("app_version");
      // if (version==null||version!=APP_VERSION) {
      //   console.log('app version updated', APP_VERSION);
      //   this.setAppVersion(APP_VERSION);
      // }
    }
  }
</script>
